export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["MIDDLE"] = "MIDDLE";
    UserRole["NORMAL"] = "NORMAL";
    UserRole["VENDOR"] = "VENDOR";
    UserRole["KIOSK"] = "KIOSK";
})(UserRole || (UserRole = {}));
